export interface DrawingCheckListType {
  id: number;
  project_id: number;
  folder_id: number;
  title: string;
  status: "Incomplete" | "Complete" | "Not Applicable";
  path?: string | null;
  file_extension?: string | null;
  file_upload_date?: string | null;
}


// to single object maping
export const mapDrawingCheckListType = (data: any): DrawingCheckListType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const singleData: DrawingCheckListType = {
        id: data.id,
        project_id: data.project_id,
        folder_id: data.folder_id,
        title: data.title ,
        status: data.status,
        path: (data.path!==null)?data.path: null,
        file_upload_date:(data.file_upload_date!==null)? data.file_upload_date:null,
        file_extension:(data.file_extension!==null)? data.file_extension:null,
    }

    return singleData;
}

// maping list objects
export const mapDrawingCheckListTypes = (data: any[]): DrawingCheckListType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapDrawingCheckListType);
}